export const SCREEN_SIZES = {
  MOBILE: {
    name: 'SMOBILE',
    minPixels: 0,
    layoutType: 'mWeb',
  },
  TABLET: {
    name: 'TABLET',
    minPixels: 640,
    layoutType: 'mWeb',
  },
  DESKTOP: {
    name: 'DESKTOP',
    minPixels: 1240,
    layoutType: 'Web',
  },
};
